<template>
    <div class="status">
        <span
            class="block w-4 h-4 rounded-full mr-3"
            :style="{ 'background-color': color }"
        ></span>
        <Select
            :options="statuses"
            :selected="status"
            @select="$emit('select', $event)"
            v-if="selector"
            m="mb-0"
            p="pl-4 pr-2"
            w="w-3/4"
            top="top-6"
        />
        <span v-else>{{ status.name }}</span>
    </div>
</template>

<script>
import Select from '../common/Select.vue';

export default {
  components: {
    Select,
  },
  props: {
    statuses: [Array, Object],
    statusCode: [String, Number],
    selector: Boolean,
  },
  computed: {
    status() {
      return this.statuses.find((item) => item.id == this.statusCode);
    },
    color() {
      return this.status ? this.status.color : 'red';
    },
  },
};
</script>

<style lang="scss" scoped>
.status {
    display: flex;
    align-items: center;
    min-width: 200px;
    background-color: var(--base-data-table-row-color);
}
</style>
